import { useLocation, useNavigate } from 'react-router-dom';

export function useQueryParams() {
  const navigate = useNavigate();
  const location = useLocation();

  const setQueryParam = (
    key: string,
    value: string | number | boolean,
    replace: boolean = true
  ) => {
    const queryParams = new URLSearchParams(location.search);
    queryParams.set(key, String(value));
    navigate({ search: queryParams.toString() }, { replace });
  };

  const deleteQueryParam = (key: string, replace: boolean = true) => {
    const queryParams = new URLSearchParams(location.search);
    queryParams.delete(key);
    navigate({ search: queryParams.toString() }, { replace });
  };

  const getQueryParam = (key: string): string | null => {
    const queryParams = new URLSearchParams(location.search);
    return queryParams.get(key);
  };

  return { setQueryParam, deleteQueryParam, getQueryParam };
}
